import { render, staticRenderFns } from "./mallProduct.vue?vue&type=template&id=a0ec2e20&scoped=true&"
import script from "./mallProduct.vue?vue&type=script&lang=js&"
export * from "./mallProduct.vue?vue&type=script&lang=js&"
import style0 from "./mallProduct.vue?vue&type=style&index=0&id=a0ec2e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ec2e20",
  null
  
)

export default component.exports